var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-screen',{staticClass:"startRegistration",attrs:{"title":_vm.$ml.get('setSecretQuestionTitleReg'),"text":_vm.$ml.get('setSecretQuestionTextReg'),"action":_vm.nextScreen,"buttonText":_vm.$ml.get('setSecretQuestionButtonReg'),"titleH1":false,"headerImg":7}})
}
var staticRenderFns = []

export { render, staticRenderFns }